import '../Admin/admin-shared.css'
import './community-panel.css'

import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Spinner } from '../../Components'
import { useAuth } from '../../Provider/AuthProvider'
import { invalidateQuery, useCQuery } from '../../Services'
import { cap } from '../../State'
import { translations } from '../../translations'
import Controlli from './Components/Controlli'
import { Editors } from './Components/Editors'
import FilterSections from './Components/FilterSections'
import HeaderSettings from './Components/HeaderSettings'
import StepChooseFormalita from './Components/StepChooseFormalita'
import StepChooseModeAI from './Components/StepChooseModeAI'
import { alert, prepareOptionsFilters, setSelectedFilters } from './Functions'
import { canSaveCommunityGroupSelection } from './groupSelection'
import { savePreset } from './saveFunctions'
const language = cap.language.state || 'IT'
const t = translations[language]

export const CommunityPanel = () => {
  const { presetId, operation } = useParams()
  const { user = {} } = useAuth()
  const navigate = useNavigate()
  const { data: [communityPreset] = [], isSuccess } = useCQuery(['communityPreset', presetId])
  const [selectedTypeSearch, setSelectedTypeSearch] = useState('')
  const [flagAbilitazione, setFlagAbilitazione] = useState(false)
  const [titolo, setTitolo] = useState('')
  const [clientCode, setClientCode] = useState({
    mastro: user.user?.environment?.codMastroCliente,
    gruppo: '',
    conto: '',
    sottoConto: ''
  })
  const [selectedClient, setSelectedClient] = useState()
  const [codiceGruppo, setCodiceGruppo] = useState('')
  const [descrizioneGruppo, setDescrizioneGruppo] = useState('')
  const [ragioneSociale, setRagioneSociale] = useState('')
  const [group, setGroup] = useState()
  const [selectedSteps, setSelectedSteps] = useState('0')
  const [selectedTone, setSelectedTone] = useState('formale')
  const [selectedPlaneFilters, setSelectedPlaneFilters] = useState([{ name: t.price, code: 'p' }])
  const [optionsPlaneFilters, setOptionsPlaneFilters] = useState([])
  const [inputPlaneValues, setInputPlaneValues] = useState([3])
  const [radiusPlane, setRadiusPlane] = useState(50)
  const [selectedTrainFilters, setSelectedTrainFilters] = useState([{ name: t.price, code: 'p' }])
  const [optionsTrainFilters, setOptionsTrainFilters] = useState([])
  const [inputTrainValues, setInputTrainValues] = useState([3])
  const [inputRimborsoTrain, setInputRimborsoTrain] = useState([3])
  const [inputNoRimborsoTrain, setInputNoRimborsoTrain] = useState([0])
  const [radiusTrain, setRadiusTrain] = useState(50)
  const [selectedHotelFilters, setSelectedHotelFilters] = useState([
    { name: t.price, code: 'p' },
    { name: t.distance, code: 'd' }
  ])
  const [optionsHotelFilters, setOptionsHotelFilters] = useState([])
  const [inputHotelValues, setInputHotelValues] = useState([2, 1])
  const [radiusHotel, setRadiusHotel] = useState(50)
  const [selectedCarFilters, setSelectedCarFilters] = useState([{ name: t.bestBuy, code: 'bb' }])
  const [optionsCarFilters, setOptionsCarFilters] = useState([])
  const [inputCarValues, setInputCarValues] = useState([3])
  const [userRedirectToOperatorMessage, setUserRedirectToOperatorMessage] = useState('')
  const [checkUserRedirectToOperatorMessage, setCheckUserRedirectToOperatorMessage] =
    useState(false)
  const [quotesMessage, setQuotesMessage] = useState('')
  const [initialMessages, setInitialMessages] = useState({})
  const [checkAutomaticHotel, setCheckAutomaticHotel] = useState(true)
  const [logicaCameraNonInPenale, setLogicaCameraNonInPenale] = useState(true)
  const [soloCamereNonInPenale, setSoloCamereNonInPenale] = useState(false)
  const [tolleranzaGiorniPenale, setTolleranzaGiorniPenale] = useState(3)
  const [servicePriority, setServicePriority] = useState([
    { id: 'Business' },
    { id: 'Premium' },
    { id: 'Executive' },
    { id: 'Standard' }
  ])
  const [trainFarePriority, setTrainFarePriority] = useState([])
  const [checkControlliIA, setCheckControlliIA] = useState(true)
  const [checkPubblicaLoStesso, setCheckPubblicaLoStesso] = useState(true)
  const [checkControllaPreventivi, setCheckControllaPreventivi] = useState(true)
  const [checkChiediMezzoDiTrasporto, setCheckChiediMezzoDiTrasporto] = useState(false)
  const [signNora, setSignNora] = useState(false)
  const [sendFinalMessage, setSendFinalMessage] = useState(false)
  const [checkMeteo, setCheckMeteo] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [defaultPreset, setDefaultPreset] = useState(false)
  const [initialDefaultPreset, setInitialDefaultPreset] = useState(false)
  const [statePreset, setStatePreset] = useState(1)

  const save = async () => {
    try {
      if (
        !canSaveCommunityGroupSelection({
          defaultPreset,
          codiceGruppo,
          descrizioneGruppo,
          group
        })
      ) {
        return alert('error', t.errore, t.groupNotFound)
      }
      if (quotesMessage && !quotesMessage.includes('#link')) {
        return alert('error', t.linkMissing, t.linkMissingDetail)
      }
      if (quotesMessage && checkMeteo && !quotesMessage.includes('#meteo')) {
        return alert('error', t.weatherInfoMissing, t.weatherInfoMissingDetail)
      }
      if (!titolo) {
        return alert('error', t.titleMissing)
      }
      if (!defaultPreset && !selectedClient && !group) {
        alert('error', t.errore, t.selectGroupOrClient)
        return
      }

      const method = presetId === 'new' || operation === 'duplicate' ? 'create' : 'patch'
      const requestData = {
        environmentId: communityPreset?.environmentId || user.user?.environmentId,
        titolo,
        selectedSteps,
        selectedTone,
        checkAutomaticHotel,
        logicaCameraNonInPenale,
        soloCamereNonInPenale: logicaCameraNonInPenale ? soloCamereNonInPenale : false,
        tolleranzaGiorniPenale,
        userRedirectToOperatorMessage,
        checkUserRedirectToOperatorMessage,
        quotesMessage,
        checkControlliIA,
        checkPubblicaLoStesso,
        checkControllaPreventivi,
        defaultPreset,
        checkMeteo,
        checkChiediMezzoDiTrasporto,
        signNora,
        sendFinalMessage,
        state: statePreset
      }
      await savePreset(group || {}, method, {
        setIsSaving,
        selectedTrainFilters,
        inputTrainValues,
        flagAbilitazione,
        inputRimborsoTrain,
        inputNoRimborsoTrain,
        selectedPlaneFilters,
        inputPlaneValues,
        selectedHotelFilters,
        inputHotelValues,
        selectedCarFilters,
        inputCarValues,
        servicePriority,
        trainFarePriority,
        selectedClient,
        ragioneSociale,
        defaultPreset,
        codiceGruppo,
        initialDefaultPreset,
        setInitialDefaultPreset,
        navigate,
        presetId,
        user,
        requestData
      })

      invalidateQuery(['communityPreset', 'communityPresets'])
      alert('success', t.salvataggioEffettuato, '')
    } catch (error) {
      alert('error', t.errore, error?.message || 'Errore durante il salvataggio')
    }
  }

  /**
   * Imposta lo stato del messaggio di invio finale.
   *
   * @param value Un valore booleano che determina se il messaggio finale deve essere inviato.
   *              Se impostato su `false`, disabilita anche il controllo meteo.
   *
   * @author: mranocchia
   */
  const customSetStateSendFinalMessage = (value) => {
    setSendFinalMessage(value)
    if (!value) {
      setCheckMeteo(false)
      setCheckUserRedirectToOperatorMessage(false)
    }
  }

  useEffect(() => {
    setOptionsPlaneFilters(prepareOptionsFilters('plane'))
    setOptionsTrainFilters(prepareOptionsFilters('train'))
    setOptionsHotelFilters(prepareOptionsFilters('hotel'))
    setOptionsCarFilters(prepareOptionsFilters('car'))

    if (communityPreset) {
      const {
        titolo,
        codiceGruppo: codiceG,
        descrizione: descG,
        ragioneSociale,
        selectedSteps,
        selectedTone,
        selectedPlaneFilters,
        selectedCarFilters,
        selectedTrainFilters,
        selectedHotelFilters,
        checkAutomaticHotel,
        logicaCameraNonInPenale,
        soloCamereNonInPenale,
        tolleranzaGiorniPenale,
        checkUserRedirectToOperatorMessage,
        userRedirectToOperatorMessage,
        redirectToOperatorMessage,
        quotesMessage,
        servicePriority,
        trainFarePriority,
        checkControlliIA,
        checkPubblicaLoStesso,
        checkControllaPreventivi,
        state
      } = communityPreset
      setTitolo(titolo)
      setClientCode({
        mastro: communityPreset.codiceCliente?.slice(0, 2),
        gruppo: communityPreset.codiceCliente?.slice(2, 4),
        conto: communityPreset.codiceCliente?.slice(4, 6),
        sottoConto: communityPreset.codiceCliente?.slice(6, 12)
      })
      if (operation !== 'duplicate') {
        setCodiceGruppo(codiceG)
        setDescrizioneGruppo(descG)
      } else {
        setCodiceGruppo('')
        setDescrizioneGruppo('')
        setGroup()
      }
      if (communityPreset.codiceCliente) {
        setSelectedTypeSearch('CL')
      } else if (communityPreset.codiceGruppo) {
        setSelectedTypeSearch('GR')
      }
      setRagioneSociale(ragioneSociale)
      setSelectedSteps(selectedSteps?.toString())
      setSelectedTone(selectedTone)
      setSelectedFilters(
        selectedTrainFilters,
        setInputTrainValues,
        setSelectedTrainFilters,
        setInputRimborsoTrain,
        setInputNoRimborsoTrain
      )
      setSelectedFilters(selectedPlaneFilters, setInputPlaneValues, setSelectedPlaneFilters)
      setSelectedFilters(selectedHotelFilters, setInputHotelValues, setSelectedHotelFilters)
      setSelectedFilters(selectedCarFilters, setInputCarValues, setSelectedCarFilters)
      setLogicaCameraNonInPenale(logicaCameraNonInPenale === 1)
      setSoloCamereNonInPenale(soloCamereNonInPenale === 1)
      setTolleranzaGiorniPenale(tolleranzaGiorniPenale)
      setUserRedirectToOperatorMessage(userRedirectToOperatorMessage)
      setCheckUserRedirectToOperatorMessage(checkUserRedirectToOperatorMessage === 1)
      setQuotesMessage(quotesMessage)
      setServicePriority(servicePriority)
      setTrainFarePriority(trainFarePriority || [])
      setCheckControlliIA(checkControlliIA === 1)
      setCheckAutomaticHotel(checkAutomaticHotel === 1)
      setCheckPubblicaLoStesso(checkPubblicaLoStesso === 1)
      setCheckControllaPreventivi(checkControllaPreventivi === 1)
      setStatePreset(state === 1)
      setInitialMessages({
        redirectToOperatorMessage,
        quotesMessage,
        userRedirectToOperatorMessage
      })
      setCheckMeteo(communityPreset.checkMeteo === 1)
      setCheckChiediMezzoDiTrasporto(communityPreset.checkChiediMezzoDiTrasporto === 1)
      setSignNora(communityPreset.signNora === 1)
      setSendFinalMessage(communityPreset.sendFinalMessage === 1)
      if (operation === 'duplicate') {
        setDefaultPreset(false)
        setInitialDefaultPreset(false)
      } else {
        setDefaultPreset(communityPreset.defaultPreset === 1)
        setInitialDefaultPreset(communityPreset.defaultPreset === 1)
      }
      if (codiceG && descG && operation !== 'duplicate') {
        setGroup({ codice: codiceG, descrizione: descG })
      }
    }
    if (user.user?.environment?.enableRimborsabile) {
      setFlagAbilitazione(!!user.user?.environment?.enableRimborsabile)
    }
  }, [communityPreset, user?.user?.environment?.enableRimborsabile])

  const isNewPreset = presetId === 'new'
  const isDuplicatePreset = operation === 'duplicate'
  const isExistingPreset = !isNewPreset && !isDuplicatePreset

  const groupOrDefault = clientCode?.sottoConto || group || defaultPreset

  const presetNewCondition = isNewPreset && groupOrDefault
  const presetModifyCondition = isExistingPreset && groupOrDefault
  const presetDuplicateCondition = isDuplicatePreset && groupOrDefault

  const visibilityCondition =
    presetNewCondition || presetModifyCondition || presetDuplicateCondition
  const { b4bEnabled = 0 } = user.user?.environment || {}
  if (!isSuccess) return <Spinner />

  return (
    <div className="community-panel-page admin-page--wide">
      <HeaderSettings
        presetId={presetId}
        clientCode={[clientCode, setClientCode]}
        selectedClient={[selectedClient, setSelectedClient]}
        save={save}
        codiceGruppo={[codiceGruppo, setCodiceGruppo]}
        ragioneSociale={[ragioneSociale, setRagioneSociale]}
        descrizioneGruppo={[descrizioneGruppo, setDescrizioneGruppo]}
        group={[group, setGroup]}
        titolo={[titolo, setTitolo]}
        defaultPreset={[defaultPreset, setDefaultPreset]}
        initialDefaultPreset={[initialDefaultPreset, setInitialDefaultPreset]}
        operation={operation}
        selectedTypeSearch={[selectedTypeSearch, setSelectedTypeSearch]}
        visibilityCondition={visibilityCondition}
        statePreset={[statePreset, setStatePreset]}
        isSaving={isSaving}
      />
      {visibilityCondition && (
        <>
          <div className="ngrid-2 community-steps-grid">
            <StepChooseFormalita selectedTone={[selectedTone, setSelectedTone]} />
            <StepChooseModeAI
              selectedSteps={[selectedSteps, setSelectedSteps]}
              b4bEnabled={b4bEnabled}
            />
          </div>
          {selectedSteps === '2' && (
            <div className="community-sections-stack">
              <FilterSections
                plane={{
                  selectedFilters: [selectedPlaneFilters, setSelectedPlaneFilters],
                  optionsFilters: [optionsPlaneFilters, setOptionsPlaneFilters],
                  inputValues: [inputPlaneValues, setInputPlaneValues],
                  radius: [radiusPlane, setRadiusPlane]
                }}
                train={{
                  selectedFilters: [selectedTrainFilters, setSelectedTrainFilters],
                  optionsFilters: [optionsTrainFilters, setOptionsTrainFilters],
                  inputValues: [inputTrainValues, setInputTrainValues],
                  inputRimborso: [inputRimborsoTrain, setInputRimborsoTrain],
                  inputNoRimborso: [inputNoRimborsoTrain, setInputNoRimborsoTrain],
                  radius: [radiusTrain, setRadiusTrain],
                  servicePriority: [servicePriority, setServicePriority],
                  flagAbilitazione: [flagAbilitazione, setFlagAbilitazione],
                  trainFarePriority: [trainFarePriority, setTrainFarePriority]
                }}
                car={{
                  selectedFilters: [selectedCarFilters, setSelectedCarFilters],
                  optionsFilters: [optionsCarFilters, setOptionsCarFilters],
                  inputValues: [inputCarValues, setInputCarValues]
                }}
                hotel={{
                  selectedFilters: [selectedHotelFilters, setSelectedHotelFilters],
                  optionsFilters: [optionsHotelFilters, setOptionsHotelFilters],
                  inputValues: [inputHotelValues, setInputHotelValues],
                  radius: [radiusHotel, setRadiusHotel],
                  logicaCameraNonInPenale: [logicaCameraNonInPenale, setLogicaCameraNonInPenale],
                  soloCamereNonInPenale: [soloCamereNonInPenale, setSoloCamereNonInPenale],
                  tolleranzaGiorniPenale: [tolleranzaGiorniPenale, setTolleranzaGiorniPenale]
                }}
                flagAbilitazioneAuto={user.user?.environment?.enableAuto}
              />
            </div>
          )}

          <Editors
            checkMeteo={checkMeteo}
            quotesMessage={[quotesMessage, setQuotesMessage]}
            selectedSteps={selectedSteps}
            initialMessages={initialMessages}
          />
          <Controlli
            userRedirectToOperatorMessage={[
              userRedirectToOperatorMessage,
              setUserRedirectToOperatorMessage
            ]}
            checkUserRedirectToOperatorMessage={[
              checkUserRedirectToOperatorMessage,
              setCheckUserRedirectToOperatorMessage
            ]}
            checkAutomaticHotel={[checkAutomaticHotel, setCheckAutomaticHotel]}
            checkControlliIA={[checkControlliIA, setCheckControlliIA]}
            checkPubblicaLoStesso={[checkPubblicaLoStesso, setCheckPubblicaLoStesso]}
            checkControllaPreventivi={[checkControllaPreventivi, setCheckControllaPreventivi]}
            checkChiediMezzoDiTrasporto={[
              checkChiediMezzoDiTrasporto,
              setCheckChiediMezzoDiTrasporto
            ]}
            signNora={[signNora, setSignNora]}
            sendFinalMessage={[sendFinalMessage, customSetStateSendFinalMessage]}
            selectedSteps={selectedSteps}
            checkMeteo={[checkMeteo, setCheckMeteo]}
            initialMessages={initialMessages}
          />
          <div className="community-save-row">
            <button type="button" className="nbtn nbtn--primary" onClick={save} disabled={isSaving}>
              <i className="pi pi-check" style={{ fontSize: 14 }} />
              {t.salva}
            </button>
          </div>
        </>
      )}
    </div>
  )
}
